var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKmslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26144 3.6743C3.15195 3.6743 3.04694 3.71779 2.96951 3.79522C2.89209 3.87264 2.84859 3.97765 2.84859 4.08715V5.73856H3.6743V4.5H4.91285V5.53213L6.35783 4.08715L4.91285 2.64217V3.6743H3.26144ZM4.79189 0.120878L8.87912 4.20811C8.95652 4.28554 9 4.39053 9 4.5C9 4.60947 8.95652 4.71447 8.87912 4.79189L4.79189 8.87912C4.71447 8.95652 4.60947 9 4.5 9C4.39053 9 4.28554 8.95652 4.20811 8.87912L0.120878 4.79189C0.0434797 4.71447 0 4.60947 0 4.5C0 4.39053 0.0434797 4.28554 0.120878 4.20811L4.20811 0.120878C4.28554 0.0434797 4.39053 0 4.5 0C4.60947 0 4.71447 0.0434797 4.79189 0.120878Z",
    fill: "#D83F87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmslogo);
export default __webpack_public_path__ + "static/media/km'slogo.ea77275a10c9bce602ce98d6e0e6d62d.svg";
export { ForwardRef as ReactComponent };